import { fg } from '@atlaskit/platform-feature-flags';

import { HUB_LOGO_HEIGHT, HUB_LOGO_HEIGHT_LEGACY } from '../constants';

/**
 * Returns the appropriate logo height based on hub type and feature gate status.
 *
 * @param hubType - The type of hub (HELP_HUB, CUSTOMER_SERVICE, etc.)
 * @returns The logo height as a CSS string ('32px' or '40px')
 *
 * Logic:
 * - HELP_HUB: Always returns 32px (new standard)
 * - CUSTOMER_SERVICE: Returns 32px if feature gate 'csm_hub_logo_height_32px' is enabled, otherwise 40px
 * - Other hub types: Returns 40px (legacy fallback)
 */
export const getHubLogoHeight = (hubType: string | null | undefined): string => {
	// Help hubs always use new height
	if (hubType === 'HELP_HUB') {
		return HUB_LOGO_HEIGHT;
	}
	// CSM hubs use new height only if feature gate is enabled
	if (hubType === 'CUSTOMER_SERVICE' && fg('csm_hub_logo_height_32px')) {
		return HUB_LOGO_HEIGHT;
	}
	// Fallback to legacy height for CSM and other hub types
	return HUB_LOGO_HEIGHT_LEGACY;
};
